import { Spinner } from "@olxbr/ds-web";
import styled from "styled-components";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--z-index-950-popup);
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`


export const LoadingBackdrop = () => (<Backdrop><Spinner aria-label="Carregando" size="large" /></Backdrop>)
